"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Orbus Artwork Uploader
 * Artwork uploader, PDF preflight queue & processor.  Please refer to the [AWS Developer Guide](https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingRESTAPImpUpload.html) for multipart uploads.  The upload-related methods do not take file data themselves, rather they act as helper methods for using the AWS S3 APIs.  It is strongly recommended that you use Uppy and its [AWS S3 Multipart plugin](https://uppy.io/docs/aws-s3-multipart/) to assist with uploading files. The provided demo/example code offers a functioning example.
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MergeApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 * no description
 */
class MergeApi extends runtime.BaseAPI {
    /**
     * Get the result of a merge operation.
     */
    downloadMergeOutputRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
                throw new runtime.RequiredError('jobId', 'Required parameter requestParameters.jobId was null or undefined when calling downloadMergeOutput.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/merge/download/{jobId}/merged.pdf`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Get the result of a merge operation.
     */
    downloadMergeOutput(jobId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.downloadMergeOutputRaw({ jobId: jobId });
        });
    }
    /**
     * Perform a merge of two finished jobs
     */
    mergeRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.MergeInputs === null || requestParameters.MergeInputs === undefined) {
                throw new runtime.RequiredError('MergeInputs', 'Required parameter requestParameters.MergeInputs was null or undefined when calling merge.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/merge/merge-files`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.MergeInputsToJSON(requestParameters.MergeInputs),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.MergeFilesResponseFromJSON(jsonValue));
        });
    }
    /**
     * Perform a merge of two finished jobs
     */
    merge(MergeInputs) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mergeRaw({ MergeInputs: MergeInputs });
            return yield response.value();
        });
    }
}
exports.MergeApi = MergeApi;
